(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Ivrita"));
	else if(typeof define === 'function' && define.amd)
		define(["Ivrita"], factory);
	else if(typeof exports === 'object')
		exports["Ivrita"] = factory(require("Ivrita"));
	else
		root["Ivrita"] = root["Ivrita"] || {}, root["Ivrita"]["ui"] = factory(root["Ivrita"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__242__) {
return 